import { Headphones } from 'lucide-react';
import { session } from '../lib/session';
import { targetLabel, useStore } from '../store';
import { Drawer } from './ui';

/** Per-key listen levels (Unity's "volume" page). */
export function MixerDrawer({ onClose }: { onClose: () => void }) {
  const panel = useStore((s) => s.panel);
  const channels = useStore((s) => s.channels);
  const listening = useStore((s) => s.listening);
  const volumes = useStore((s) => s.settings.keyVolumes);
  const master = useStore((s) => s.settings.masterVolume);

  const keys = (panel?.keys ?? []).filter((k) => k.listen !== 'none');

  return (
    <Drawer title="Mixer" onClose={onClose}>
      <div className="drawer__body">
        <div className="mixer-row">
          <span className="mixer-row__label">MASTER</span>
          <input
            className="range"
            type="range"
            min={0}
            max={1}
            step={0.02}
            value={master}
            onChange={(e) => {
              session.audio.setMasterVolume(Number(e.target.value));
              useStore.setState((s) => ({ settings: { ...s.settings, masterVolume: Number(e.target.value) } }));
            }}
            onPointerUp={() => void session.applyAudioSettings()}
          />
          <span className="mixer-row__val">{Math.round(master * 100)}</span>
        </div>
        {keys.map((k) => {
          const on = k.listen === 'always' || k.targets.every((t) => listening.includes(t));
          const label = k.label ?? k.targets.map((t) => targetLabel(t, true)).join('+');
          const first = k.targets[0].startsWith('ch:') ? channels.find((c) => `ch:${c.id}` === k.targets[0]) : null;
          const v = volumes[k.id] ?? 0.8;
          return (
            <div key={k.id} className="mixer-row" data-sw={k.color ?? first?.color ?? 'cyan'} style={{ opacity: on ? 1 : 0.45 }}>
              <span className="mixer-row__label" title={label}>
                <Headphones size={11} style={{ verticalAlign: -1, marginRight: 4 }} />
                {label.slice(0, 8)}
              </span>
              <input className="range" type="range" min={0} max={1} step={0.02} value={v} onChange={(e) => session.setKeyVolume(k.id, Number(e.target.value))} />
              <span className="mixer-row__val">{Math.round(v * 100)}</span>
            </div>
          );
        })}
      </div>
    </Drawer>
  );
}
